import { render, staticRenderFns } from "./OrderReceiptPopup.vue?vue&type=template&id=4d6fbaf1"
import script from "./OrderReceiptPopup.vue?vue&type=script&lang=js"
export * from "./OrderReceiptPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderReceiptPopup.vue?vue&type=style&index=0&id=4d6fbaf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports